module.exports = __webpack_public_path__ + "img/logo-20-years-white.1ae7739d.png";